import classes from './index.module.scss';
import TimerDialog from '../../components/TimerDialog';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { authStatusEnum, setStatus } from '../../store/auth/authSlice';
import { GoInFullscreen } from '../../utils/helper';

const TimerPage = () => {
  const dispatch = useAppDispatch();
  const [startTime, setStartTime] = useState(5);

  useEffect(() => {
    const localTimer = setInterval(() => {
      startTime > 0 && setStartTime((prev) => prev - 1);
    }, 1000);
    if (startTime < 1) clearInterval(localTimer);
    return () => clearInterval(localTimer);
  }, [startTime]);

  useEffect(() => {
    if (startTime < 1) {
      dispatch(setStatus(authStatusEnum.AUTHENITICATED));
    }
  }, [startTime]);

  useEffect(() => {
    GoInFullscreen();
  }, []);

  return (
    <div>
      <TimerDialog open={startTime > 0} time={startTime} />
    </div>
  );
};

export default TimerPage;
